import * as YUP from 'yup'

import { msgs } from '../../services/Validation/msgs'

export const EditOrderValidation = YUP.object().shape({
    client_id :YUP.number().min(0,msgs.min_msg(0)).required(msgs.required_msg),
    order_no:YUP.string().min(1,msgs.min_msg(1)).max(30,msgs.max_msg(30)).required(msgs.required_msg),
    date:YUP.string().required(msgs.required_msg),
    delivery_date:YUP.string(),
    summary:YUP.string().required(msgs.required_msg),
    order_details:YUP.array().of(YUP.object().shape({
        glass_id:YUP.number().min(1,msgs.required_msg).required(msgs.required_msg),
        glass_work_id:YUP.number().min(1,msgs.required_msg).required(msgs.required_msg),
        price:YUP.number().when('raw_price',([raw_price],schema)=>{
         
          if (raw_price) {
            let threshold_max = (0.1 * raw_price) + raw_price
            let threshold_min= raw_price - (0.1 * raw_price)
            
            return schema.max(threshold_max,msgs.max_msg(parseFloat(threshold_max.toFixed(2))))
                         .min(threshold_min,msgs.min_msg(parseFloat(threshold_min.toFixed(2))))
          }
          return schema
        })

    })).min(1,msgs.required_msg)

})


export const AddOrderValidation =
(
    checkIfClientExisted:(value: string, client_list:any[])=>{client_id:number,client_name:string}|null
,client_list:any[])=>
 YUP.object().shape({
    client: YUP.object().shape({
      id: YUP.number().required(msgs.required_msg),
    }),
    summary: YUP.string(),
    delivery_date: YUP.string(),
    date: YUP.string().required(msgs.required_msg),
   
    order_details: YUP.array().of(
        YUP.object().shape({
          glass_id: YUP.number().min(1,msgs.required_msg).required(msgs.required_msg),
         
          glass_work_id: YUP.number().min(1,msgs.required_msg).required(msgs.required_msg),
           price:YUP.number().when('raw_price',([raw_price],schema)=>{
         
          if (raw_price) {
            let threshold_max = (0.1 * raw_price) + raw_price
            let threshold_min= raw_price - (0.1 * raw_price)
            
            return schema.max(threshold_max,msgs.max_msg(parseFloat(threshold_max.toFixed(2))))
                         .min(threshold_min,msgs.min_msg(parseFloat(threshold_min.toFixed(2))))
          }
          return schema
        })
        }),
      ).min(1,msgs.required_msg),
    client_number: YUP.string().required(msgs.required_msg).test(
      'fn',
      (d) => { }
      , function (value: string | undefined) {
        if (value) {
        
          let client = checkIfClientExisted(value,client_list)
        
          if (!client) {
            return this.createError(
              {message: msgs.valid_client_number})
          }
          return undefined
        }
      })

  })